const axios = require('@axios').default
const {
  guardSubscriptionAction,
  ActionRequirement,
} = require('@/libs/subscriptionActionGuard')

module.exports = {
  prevPanel() {
    console.log('prevPanel',this.activePanel)
    if (this.welcomeActive) {
      console.log('welcomeActive',this.activePanel)
      if (this.activePanel === 0) {
        return;
      } else {
        this.activePanel--;
      }
      this.$refs.welcome.prevPanel();
    } else {
      console.log('welcomeNotActive',this.activePanel)
      let tutorialIndex = this.intros.indexOf(true);
      this.buttonActive = false;
      this.activePanel--;
      this.$refs["tut" + tutorialIndex].prevPanel();
    }
  },
  nextPanel() {
    console.log('nextPanel',this.activePanel)
    if (this.welcomeActive) {
      console.log('welcomeActive',this.activePanel)
      this.buttonActive = false;
      this.$refs.welcome.goNext();
      if (this.activePanel === 1) {
        setTimeout(() => {
          this.activePanel++;
        }, 550);
      } else {
        this.activePanel++;
      }
    } else {
      console.log('welcomeNotActive',this.activePanel)
      let tutorialIndex = this.intros.indexOf(true);
      this.buttonActive = false;
      this.activePanel++;
      this.$refs["tut" + tutorialIndex].nextPanel();
    }
  },
  activateButton() {
    this.buttonActive = true;
  },
  goBack() {
    console.log('goBack',this.activePanel)
    this.headerActive = false;
    this.$set(this.intros, 0, false);
    this.activePanel = 0;
    setTimeout(() => {
      this.welcomeActive = true;
      setTimeout(() => {
        this.tutKeys[0]++;
      }, 0);
    }, 550);
  },
  welcomePassed() {
    console.log('welcomePass',this.activePanel);
    this.activePanel = 0;
    this.welcomeActive = false;
    setTimeout(() => {
      this.activePanel = 0;
      // change this to 0 when you want to start from the beginning
      this.$set(this.intros, 0, true);
      // this.tutKeys[0]++;
    }, 550);
  },
  partComplete(index) {
    console.log('partComplete',this.activePanel);
    this.activePanel = 0;
    this.testAreaActive = false;
    setTimeout(() => {
      this.headerActive = true;
      this.footerActive = true;
      this.$set(this.intros, index + 1, true);
      // this.intros[index + 1] = true;
    }, 550);
  },
  // L7: the entitlement guard below is only a client-side read of status — it
  // leaves no trace the server can bind the result POST's 6-hour
  // post-rejection grace to. This call is that trace: a server-issued attempt
  // lease, opened on a route that requires clean standing.
  //
  // Best-effort by design. An entitlement answer from the server (402/403) is
  // fresher than the guard's and stops the test. Anything else — offline, 5xx,
  // timeout — must not: losing the lease costs a rejected-mid-test user their
  // grace, while refusing to start would cost every user their test over a
  // transient hiccup.
  async openTestAttemptLease(decision) {
    try {
      await axios.post(`/test/${this.$route.params.id}/start`)
    } catch (error) {
      const status = error && error.response && error.response.status
      if (status === 402 || status === 403) return { ...decision, allowed: false }
    }
    return decision
  },
  async tutorialDone(tutorialNumber) {
    // TestCard performs an early UX preflight, but users can also reach this
    // page directly and entitlement can change while the tutorial is open.
    // The first question activation is the actual new-work boundary. Later
    // parts are continuation of that same test and keep the final-submit
    // subscription-only grace policy.
    if (tutorialNumber === 0) {
      if (this.testStartInFlight) return
      this.testStartInFlight = true
      let decision
      try {
        decision = await guardSubscriptionAction({
          requirement: ActionRequirement.SUBSCRIPTION_AND_STANDING,
          source: 'test-start',
          forceRefresh: true,
        })
        if (decision && decision.allowed) {
          decision = await this.openTestAttemptLease(decision)
        }
      } catch (error) {
        decision = null
      } finally {
        this.testStartInFlight = false
      }
      if (!decision || !decision.allowed) return
    }

    this.headerActive = false;
    this.footerActive = false;
    this.footer = false;
    console.log('tutorialDone',this.activePanel,'tutorialNumber',tutorialNumber)
    this.activePanel = 0;
    this.$set(this.intros, tutorialNumber, false);
    // this.intros[tutorialNumber] = false;
    setTimeout(() => {
      this.testAreaActive = true;
      this.idk = tutorialNumber + 1;
    }, 500);
  },
  refresh(index) {
    console.log('refresh',this.activePanel);
    this.activePanel = 0;
    this.$set(this.intros, index, false);
    setTimeout(() => {
      this.$set(this.intros, index, true);
    }, 550);
  },
};
